import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <style />
    <path
      fill={ fill }
      d="M24 13.57H13.57V24h-3.14V13.57H0v-3.14h10.43V0h3.14v10.43H24z"
      id="prefix__Layer_1"
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
